// Only locale names backed by bundled translations may be selected.
export function resolveLanguage(queryLanguage, savedLanguage, currentLanguage, availableLocales, navigating = false) {
  const preferred = navigating ? [currentLanguage, savedLanguage] : [savedLanguage, currentLanguage]
  return [queryLanguage, ...preferred, 'en-US', availableLocales[0]]
    .find(value => typeof value === 'string' && availableLocales.includes(value))
}
